// "Scheduling mode": a student picked from the nav search (calendar icon) is
// pre-selected in the open slot quick look (Single Drive, Observation, Drive Test).
// Kept in sessionStorage so it survives day changes and reloads, but stays per tab.

const STORAGE_KEY = "driveato.schedulingPupil";
export const SCHEDULING_PUPIL_CHANGED_EVENT = "scheduling-pupil:changed";

export function getSchedulingPupil() {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const pupil = JSON.parse(raw);
    return pupil && pupil.id ? pupil : null;
  } catch (_e) {
    return null;
  }
}

export function setSchedulingPupil(pupil) {
  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ id: pupil.id, name: pupil.name })
    );
  } catch (_e) {
    // Storage unavailable (private mode etc.) — mode just won't persist.
  }
  dispatchChanged(pupil);
}

export function clearSchedulingPupil() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (_e) {}
  dispatchChanged(null);
}

// Appends prefill_pupil_id to a quick look URL when scheduling mode is on.
export function withSchedulingPupilParam(url) {
  const pupil = getSchedulingPupil();
  if (!pupil) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}prefill_pupil_id=${encodeURIComponent(pupil.id)}`;
}

function dispatchChanged(pupil) {
  document.dispatchEvent(
    new CustomEvent(SCHEDULING_PUPIL_CHANGED_EVENT, { detail: { pupil } })
  );
}
